import React, { useState, useRef, useEffect } from 'react';
import './LiveChatToggle.css';

const LiveChatToggle = () => {
    const [isChatVisible, setChatVisible] = useState(false);
    const iframeRef = useRef(null);

    const toggleChat = (e) => {
        e.preventDefault();
        setChatVisible(!isChatVisible);
    };

    useEffect(() => {
        if (isChatVisible && window.iFrameResize && iframeRef.current) {
            window.iFrameResize({
                log: false,
                checkOrigin: false,
                // heightCalculationMethod: 'bodyScroll',
                license: 'GPLv3',
                onResized: (messageData) => {
                    console.log('Iframe resized:', messageData.height, 'x', messageData.width);
                },
            }, iframeRef.current);
        }
    }, [isChatVisible]);

    return (
        <div>
            <div className={`layer-live-chat ${isChatVisible ? 'active' : ''}`}>
                <span className="active-chat" onClick={toggleChat}>
                    <a href="#">
                        <img
                            src="https://hanbiro.com/images/ico-livechat.png"
                            alt="Live Chat Icon"
                            style={{ width: '30px', height: '30px' }}
                        />
                        <span>1:1 상담</span>
                    </a>
                </span>

                <iframe
                    ref={iframeRef}
                    src="https://n.hanbiro.com/ngw/livechat2"
                    title="Live Chat"
                    className="frame-box"
                    id="livechat-frame"
                    height={'auto'}
                    style={{ display: isChatVisible ? 'block' : 'none', width: '100%', border: 'none' }}
                />
            </div>

            <a href="https://hanbiro.com/software/free-trial.html" className="btn-demo">
                <img
                    src="https://hanbiro.com/images/ico-demo.png"
                    style={{ width: '30px', height: '30px' }}
                    alt="Demo Icon"
                />
                <span>데모 신청</span>
            </a>
        </div>
    );
};

export default LiveChatToggle;
